import { Outlet } from 'react-router-dom';
import Meta from '../../components/Meta';
import Header from '../../components/Header';

function Template() {
	return (
		<>
			<Meta title="Staff Availability" />

			<Header heading="Staff Availability" />

			<main>
				<Outlet />
			</main>
		</>
	);
}

export default Template;
